export const hardcodedTrustPilotReviews = 19054

export const CONFUSED_REF = 'CF103AE310635'
